import {combineEpics} from 'redux-observable';

import * as authEpics from '../features/auth/store/epics';
import * as eSingleEpics from '../features/election-single/store/epics';
import * as electionEpics from '../features/election/store/epics';

export default combineEpics(
  ...Object.values(authEpics),
  ...Object.values(electionEpics),
  ...Object.values(eSingleEpics)
);



// WEBPACK FOOTER //
// ./src/store/root-epic.ts